/**
 * 環境判定ユーティリティ
 * 開発環境、検証環境、本番環境を判定し、認証方式を決定
 */

/**
 * 現在の環境を取得
 */
export const getEnvironment = () => {
  // 環境変数から明示的に指定されている場合
  const envMode = process.env.REACT_APP_ENVIRONMENT_MODE;
  if (envMode) {
    const normalized = envMode.toLowerCase();
    if (normalized === 'dev' || normalized === 'development') return 'development';
    if (normalized === 'test' || normalized === 'tst') return 'test';
    if (normalized === 'stg' || normalized === 'staging') return 'staging';
    if (normalized === 'prod' || normalized === 'production') return 'production';
  }

  // ホスト名から判定（URLベース）
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname.includes('.test.') || hostname.includes('.test-') || hostname.endsWith('.test')) {
      return 'test';
    }
    if (hostname.includes('.stg.') || hostname.includes('.staging-') || hostname.endsWith('.staging')) {
      return 'staging';
    }
    if (hostname.includes('.prod.') || hostname.includes('.production-') || hostname.endsWith('.prod')) {
      return 'production';
    }
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'development';
    }
  }

  // プロジェクトIDから判定
  const projectId = process.env.REACT_APP_GOOGLE_CLOUD_PROJECT || '';
  if (projectId.includes('prod') || projectId === 'quick-win-prod') {
    return 'production';
  }
  if (projectId.includes('test') || projectId === 'quick-win-test' || projectId === 'sej-prd-dx-test') {
    return 'test';
  }
  if (projectId.includes('stg') || projectId.includes('staging')) {
    return 'staging';
  }

  // デフォルトは開発環境
  return 'development';
};

/**
 * 開発環境かどうかを判定
 */
export const isDevelopment = () => {
  return getEnvironment() === 'development';
};

/**
 * 検証環境（test/staging）かどうかを判定
 */
export const isTestOrStaging = () => {
  const env = getEnvironment();
  return env === 'test' || env === 'staging';
};

/**
 * 本番環境かどうかを判定
 */
export const isProduction = () => {
  return getEnvironment() === 'production';
};

/**
 * SSO認証を使用するかどうかを判定
 * 開発環境ではfalse、検証環境・本番環境ではtrue
 * 環境変数REACT_APP_ENABLE_SSO_AUTHで明示的に制御可能
 * 
 * 開発環境では常にfalseを返し、デジタルツール認証なしでアクセス可能
 */
export const shouldUseSSOAuth = () => {
  // 開発環境では常にSSO認証を使用しない（デジタルツール認証なし）
  if (isDevelopment()) {
    return false;
  }

  // 環境変数で明示的に指定されている場合
  const enableSSO = process.env.REACT_APP_ENABLE_SSO_AUTH;
  if (enableSSO !== undefined) {
    return enableSSO === 'true';
  }

  // 検証環境・本番環境ではSSO認証を使用
  return isTestOrStaging() || isProduction();
};

/**
 * Basic認証を使用するかどうかを判定
 * 開発環境ではtrue、検証環境・本番環境ではfalse（SSO認証を使用）
 */
export const shouldUseBasicAuth = () => {
  return !shouldUseSSOAuth();
};

